/**
 * DailyQuests — checklist of today's Scholar Dollar quests. Completing exit tickets / Station 2
 * tasks / daily logins awards Scholar Dollars (server-side, idempotent). Shows level progress.
 */
import React, { useEffect, useState } from 'react';
import { Target, Zap, CheckCircle2, Circle, Loader2 } from 'lucide-react';
import api from '../services/api';

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('academy_token') || ''}` });

const DailyQuests = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/school/quests', { headers: authHeaders() }).then((r) => setData(r.data)).catch(() => setData(null)).finally(() => setLoading(false));
  }, []);

  if (loading) return (<div className="mb-6 border-2 border-zinc-800 p-4 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin text-orange-500" /><span className="text-xs text-zinc-500">Loading quests…</span></div>);
  if (!data) return null;
  const pct = Math.round((data.xp_into_level / data.level_step) * 100);

  return (
    <div className="mb-6 border-2 border-orange-500/30 p-5" data-testid="daily-quests">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2"><Target className="w-4 h-4 text-orange-500" /><h3 className="text-sm font-black tracking-[0.2em] uppercase">Daily Quests</h3></div>
        <div className="flex items-center gap-1.5 text-xs font-black text-yellow-400" data-testid="quests-xp-today"><Zap className="w-3.5 h-3.5" />+{data.xp_earned_today} Scholar Dollars today</div>
      </div>
      <div className="space-y-2">
        {data.quests.map((q) => (
          <div key={q.key} className={`flex items-center justify-between border-2 px-3 py-2.5 ${q.done ? 'border-emerald-500/40 bg-emerald-500/5' : 'border-zinc-800'}`} data-testid={`quest-${q.key}`}>
            <div className="flex items-center gap-2.5">
              {q.done ? <CheckCircle2 className="w-4 h-4 text-emerald-400" /> : <Circle className="w-4 h-4 text-zinc-600" />}
              <span className={`text-sm ${q.done ? 'text-white font-bold line-through decoration-zinc-600' : 'text-zinc-300'}`}>{q.label}</span>
            </div>
            <span className={`text-xs font-black ${q.done ? 'text-emerald-400' : 'text-zinc-500'}`}>+{q.xp}</span>
          </div>
        ))}
      </div>
      <div className="mt-4">
        <div className="flex justify-between text-[10px] text-zinc-500 font-bold mb-1"><span>Level {data.level} · {data.xp} Scholar Dollars earned</span><span>{data.xp_to_next} to Lv {data.level + 1}</span></div>
        <div className="h-2 bg-zinc-800 rounded-full overflow-hidden"><div className="h-full bg-gradient-to-r from-orange-600 to-orange-400" style={{ width: `${pct}%` }} /></div>
      </div>
    </div>
  );
};

export default DailyQuests;
